import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useInviteEverifyUser() {
  return useMutation({
    mutationFn: async ({ companyId, body }) => {
      const { data } = await api.post("/user/invite-everify-user", body ?? {}, {
        headers: {
          "x-company-id": String(companyId),
        },
      });
      return data;
    },
  });
}
